import { X, File, Trash2, Pencil } from 'lucide-react';
import { useState } from 'react';

interface DocEditProps {
  handleCloseEdit: () => void
}

const DocEdit: React.FC<DocEditProps> = ({ handleCloseEdit }) => {
  const [docName, setDocName] = useState('Receipt.pdf');
  const [note, setNote] = useState(
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
  );

  return (
    <div className="modal-container">
      <div className="bg-white rounded-xl p-10 w-full max-w-3xl max-h-[95vh] overflow-y-auto relative shadow-xl">
        {/* Close Button */}
        <button onClick={handleCloseEdit} className="absolute top-5 right-5">
          <X className="w-5 h-5 hover:text-gray-700" />
        </button>

        <h2 className="text-3xl text-gray-800 font-bold mb-6">Edit document</h2>

        {/* Document Name */}
        <label className="block font-medium text-gray-800 mb-1">Document name</label>
        <input
          type="text"
          value={docName}
          onChange={(e) => setDocName(e.target.value)}
          className="w-full mb-6 px-4 py-2 border rounded-lg bg-gray-100 font-normal"
        />

        {/* File Row */}
        <div className="flex items-center mb-7">
          <File className="w-4 h-4 mr-2" />
          <span className="underline mr-2 cursor-pointer">Receipt.pdf</span>
          <Trash2 className="w-4 h-4 cursor-pointer" />
        </div>

        <div className="font-medium mb-7 cursor-pointer underline">
          + Re-upload a document
        </div>

        {/* Related Transactions */}
        <div className="font-medium text-gray-800 mb-1">Related transactions</div>
        <div className="flex items-center mb-4 underline">
          To [merchant] on 18/08/2023
          <Pencil className="w-4 h-4 ml-2 cursor-pointer" />
          <Trash2 className="w-4 h-4 ml-2 cursor-pointer" />
        </div>

        {/* Notes */}
        <div className="mb-1">Note</div>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          rows={4}
          className="w-full h-48 font-normal bg-gray-100 p-3 rounded-lg resize-none mb-10"
        />

        {/* Save Button */}
        <div className="text-center">
          <button className="button-1 w-48">
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default DocEdit
